/**
 * These values correspond to the types of attachments in Schema.AttachmentType
 */

export const FILE_ATTACHMENT_TYPE: string = "FileAttachment:#Exchange";
export const ITEM_ATTACHMENT_TYPE: string = "ItemAttachment:#Exchange";
export const ITEM_ID_ATTACHMENT_TYPE: string = "ItemIdAttachment:#Exchange";
export const REFERENCE_ATTACHMENT_TYPE: string = "ReferenceAttachment:#Exchange";
export const LINK_ATTACHMENT_TYPE: string = "LinkAttachment:#Exchange";
